import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
/* The line `import { DollarSign, TrendingUp } from 'react-feather';` is importing specific icons from
the 'react-feather' library. In this case, it is importing the `DollarSign` and `TrendingUp` icons
from the library, which can be used to display these icons in the React component. These icons can
be used to enhance the visual representation of data or actions within the component. */
// import { DollarSign, TrendingUp } from 'react-feather';
import moment from 'moment';
import Sidebar from '../../list/Sidebar';
// import { handleConfirmCancel, handleError } from '@components/toast';
// import { useNavigate } from 'react-router-dom';
// import { DISABLE_USER } from '../../../../graphql/Mutation/users';
// import { useMutation } from '@apollo/client';
import { MonthsComponent } from './MonthsComponent';
import ExportToXLSXButton from './ExportToXLSXButton';

const UserInfo = ({ data, refetch }) => {
  const defaultValuess = {
    country: data.country,
    email: data.email,
    fullName: data.fullName,
    membership: data.membership,
    phone: data?.phone?.slice(3),
    phonecode: data?.phone?.slice(0, 3),
    status: data.status,
    __typename: data.__typename,
    _id: data._id
  };
  // const navigate = useNavigate();
  // const [fechDelete] = useMutation(DISABLE_USER);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const getInitials = (str) => {
    const results = [];
    str?.split(' ').forEach((e) => {
      results.push(e[0]);
    });
    return results.slice(0, 2).join('');
  };

  const getGender = (gender) => {
    switch (gender) {
      case 'MALE': {
        return 'Masculino';
      }
      case 'FEMALE': {
        return 'Femenino';
      }
      default: {
        return 'Otro';
      }
    }
  };

  const getMembership = (memb) => {
    switch (memb) {
      case 'FREE': {
        return 'Free';
      }
      case 'FREEMIUM': {
        return 'Freemium';
      }
      case 'PREMIUM': {
        return 'Premium';
      }
      default: {
        return '';
      }
    }
  };

  // const handleDelete = async () => {
  //   handleConfirmCancel('delete', true, async () => {
  //     try {
  //       await fechDelete({ variables: { id: data._id } });
  //       navigate('/users/list');
  //       // setRefetchQuery(!refetchQuery);
  //     } catch (e) {
  //       handleError(e);
  //       throw e;
  //     }
  //   });
  // };

  return (
    <>
      <Card body>
        <Row>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <Col className="d-flex">
                  <Col md={4} className="mb-1">
                    <div
                      style={{
                        background: '#fff4e9',
                        color: '#ff9f43',
                        fontSize: 35,
                        fontWeight: 600,
                        padding: 10,
                        width: '85px',
                        height: '85px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '6px'
                      }}
                    >
                      {getInitials(data.fullName)}
                    </div>
                  </Col>
                  <Col>
                    <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: 14
                      }}
                    >
                      {data.fullName}
                    </div>
                    <div
                      style={{
                        fontSize: 12
                      }}
                    >
                      {data.email}
                    </div>

                    <Col
                      sm="6"
                      md="11"
                      lg="10"
                      className="mt-1 d-flex justify-content-start gap-1"
                    >
                      <Col sm={4}>
                        <Button color="primary" onClick={toggleSidebar}>
                          Editar
                        </Button>
                      </Col>
                      <Col className="">
                        <ExportToXLSXButton userId={data._id} />
                      </Col>
                    </Col>
                  </Col>
                </Col>
                <MonthsComponent userId={data._id} />
              </Col>
            </Row>
          </Col>

          <Col md={3} style={{ padding: '5px' }}>
            <Col>
              <Col
                md={12}
                className="d-flex justify-content-between align-items-center mb-1"
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Plan actual
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {getMembership(data.membership)}
                </div>
              </Col>
              <Col
                md={12}
                className="d-flex justify-content-between align-items-center mb-1"
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Pais
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {data.country}
                </div>
              </Col>
              <Col
                md={12}
                className="d-flex justify-content-between align-items-center"
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Telefono
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {data.phone}
                </div>
              </Col>
            </Col>
          </Col>

          <Col md={3} style={{ padding: '5px' }}>
            <Row>
              <Col
                className="d-flex justify-content-between align-items-center mb-1"
                md={12}
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Registro
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {moment(data.createdAt).format('D-M-Y-h:mm')}
                </div>
              </Col>
              <Col
                className="d-flex justify-content-between align-items-center mb-1"
                md={12}
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Genero
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {getGender(data.gender)}
                </div>
              </Col>
              <Col
                className="d-flex justify-content-between align-items-center mb-1"
                md={12}
              >
                <div
                  style={{
                    color: '#6D6B7B',
                    fontSize: 12,
                    fontWeight: 600
                  }}
                >
                  Estado
                </div>
                <div
                  style={{
                    fontSize: 12
                  }}
                >
                  {data.status ? 'Activo' : 'Inactivo'}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <Sidebar
        open={sidebarOpen}
        toggleSidebar={toggleSidebar}
        defaultValues={defaultValuess}
        handleFetching={refetch}
      />
    </>
  );
};

export default UserInfo;
